import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { LatestUpdate } from "../models/latestupdate";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class LatestUpdateService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Create a latest update
     * @param latestupdate
     */
    create(latestUpdate: LatestUpdate): Observable<Response> {
        return super.post("/api/latestupdate", latestUpdate).pipe(map((res: any) => res));
    }

    /**
     * Update a latest update
     * @param latestupdate
     */
    update(latestUpdate: LatestUpdate): Observable<LatestUpdate> {
        return super.put("/api/latestupdate", latestUpdate).pipe(map((res: any) => res));
    }

    /**
     * Get a list of all updates
     */
    getUpdate(id: number): Observable<LatestUpdate> {
        return super.get(`/api/latestupdate/${id}`).pipe(map((res: any) => res));
    }

    /**
     * Get a list of all updates
     */
    getUpdates(): Observable<LatestUpdate[]> {
        return super.get(`/api/latestupdate`).pipe(map((res: any) => res));
    }
}






